module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-bare-2dbbe255c5e7aa29023cf30a08f920a4.png";